var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dr-file-viewer-formatErr_wrapper"},[_c('div',{staticClass:"dr-file-viewer-formatErr_circle"},[_c('v-icon',{attrs:{"size":"100","color":"#848484d4"}},[_vm._v("mdi-text-box")]),_c('span',[_vm._v(_vm._s(_vm.text))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }